import en from './locales/en';
import de from './locales/de';
import fr from './locales/fr';
import es from './locales/es';
import pt from './locales/pt';
import it from './locales/it';
import nl from './locales/nl';
import ro from './locales/ro';
import pl from './locales/pl';
import cs from './locales/cs';
import sk from './locales/sk';
import hu from './locales/hu';
import el from './locales/el';
import bg from './locales/bg';
import hr from './locales/hr';
import sr from './locales/sr';
import sl from './locales/sl';
import da from './locales/da';
import sv from './locales/sv';
import no from './locales/no';
import fi from './locales/fi';
import lt from './locales/lt';
import lv from './locales/lv';
import et from './locales/et';
import tr from './locales/tr';
import uk from './locales/uk';
import zh from './locales/zh';
import ja from './locales/ja';
import ar from './locales/ar';

const catalog = {
  en, de, fr, es, pt, it, nl, ro, pl,
  cs, sk, hu, el, bg, hr, sr, sl,
  da, sv, no, fi, lt, lv, et, tr, uk,
  zh, ja, ar
};

export default catalog;



// WEBPACK FOOTER //
// app/intl/catalog.js